import React, { useEffect } from "react";

interface CustomAlertProps {
  message: string;
  type?: "success" | "error" | "warning";
  onClose: () => void;
  duration?: number; // Duration in milliseconds before auto-close
}

const CustomAlert: React.FC<CustomAlertProps> = ({
  message,
  type = "error",
  onClose,
  duration = 5000,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const bgColor = {
    success: "bg-green-600",
    error: "bg-red-600",
    warning: "bg-yellow-600",
  }[type];

  return (
    <div
      className={`fixed top-4 right-4 max-w-sm p-4 ${bgColor} text-offwhite rounded-lg shadow-lg flex items-center justify-between animate-fade-in-out`}
    >
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-4 text-offwhite hover:text-gray-300 transition"
      >
        ✕
      </button>
    </div>
  );
};

export default CustomAlert;
